import { ICoverageAccountStoreSegment } from './coverageAccount.interface';

export const coverageAccountStoreSelector = (state: ICoverageAccountStoreSegment) => state.coverageAccount;
